import { render, staticRenderFns } from "./AutoInfracaoPi.vue?vue&type=template&id=36fe4763&lang=pug"
import script from "./AutoInfracaoPi.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoPi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports